<template>
    <div
        class="_autoplay-wrapper"
        v-anime="{  scale: 1.2, direction: 'alternate', loop: true, easing: 'linear', duration: 1000 }"
        @click="handleUnmute"
    >
        <font-awesome-icon icon="volume-up" />
        {{ (skin.unmute_text) ? skin.unmute_text : 'Click to unmute' }}
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'Autoplay',
    computed: {
        ...mapGetters(['autoplaying', 'skin', 'muted'])
    },
    methods: {
        ...mapActions(['unMuteAutoplay']),
        handleUnmute() {
            this.unMuteAutoplay();
        }
    },
    watch: {
        autoplaying(newVal) {
            if (!newVal) {
                this.$anime.timeline().add({
                    targets: this.$el,
                    opacity: 0,
                    zIndex: '-1',
                    duration: 2000
                });
            }
        }
    }
};
</script>

<style scoped>
._autoplay-wrapper {
    position: absolute;
    top: 15px;
    right: 15px;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 15px;
    font-size: 11px;
    color: white;
    z-index: 4500;
    opacity: 1;
    padding: 7px 12px;
    cursor: pointer;
}
</style>